<template>
  <div :class="['select-container', { small: tamanho === 'pequeno' }]">
    <select
      v-model="itemEscolhido"
      @change="$emit('change', itemEscolhido)"
      :class="[
        'select-item',
        {
          selecionado: itemEscolhido !== '' && itemEscolhido !== null,
          small: tamanho === 'pequeno',
        },
      ]"
    >
      <option value="">{{ msgTodos }}</option>
      <option
        v-for="item in items"
        :key="item.id !== undefined ? item.id : (item.value ?? item.nome)"
        :value="item.id !== undefined ? item.id : item.value"
      >
        {{ item.label || formatarEnum(item.nome || item.titulo) }}
      </option>
    </select>
    <img
      src="@/assets/icons/arrow_down.svg"
      alt=""
      class="icone-filtro"
    />
  </div>
</template>

<script setup>
import { formatarEnum } from "@/utils/FormatarEntradas";

defineProps({
  items: {
    type: Array,
    required: true,
  },
  msgTodos: {
    type: String,
    default: "Todos",
  },
  tamanho: {
    type: String,
    default: "maximo",
  },
});

defineEmits(["change"]);

const itemEscolhido = defineModel({ default: "" });
</script>

<style scoped>
.select-container {
  position: relative;
  width: 100%;
}

.select-container.small {
  width: 250px;
  max-width: 250px;
}

.icone-filtro {
  position: absolute;
  top: 50%;
  right: 0.75rem;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  pointer-events: none;
}

.select-item {
  width: 100%;
  height: 38px;
  padding: 0 2.5rem 0 1rem;
  border: 1px solid var(--roxo-escuro1) !important;
  border-radius: 5px;
  font-size: 0.85rem;
  color: var(--roxo-escuro1);
  background-color: var(--branco);
  appearance: none;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.select-item.small {
  width: 100%;
  max-width: 250px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.select-item:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(86, 53, 120, 0.15);
}

.select-item.selecionado {
  border-color: #3b2078 !important;
  background-color: hsl(255, 50%, 97%) !important;
  color: #3b2078 !important;
  font-weight: 600 !important;
  box-shadow: 0 0 0 3px rgba(59, 32, 120, 0.08) !important;
}
</style>
